import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import VotePage from "@/pages/VotePage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AdminApp from "@/pages/admin/AdminApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VotePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
